import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import 'react-datepicker/dist/react-datepicker.css';
import './styles/index.scss';
import * as Sentry from '@sentry/react';
// Supports weights 100-900
import '@fontsource-variable/inter';
import { ConfigProvider } from '@shared/contexts/ConfigContext.tsx';
import handlePreloadError from '@shared/lib/handlePreloadError';
import { loadRedpenWidget } from '@shared/lib/redpenWidget';

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    environment: import.meta.env.VITE_APP_ENV,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', import.meta.env.VITE_APP_API_URL],
    // Set profilesSampleRate to 1.0 to profile every transaction.
    // Since profilesSampleRate is relative to tracesSampleRate,
    // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
    // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
    // results in 25% of transactions being profiled (0.5*0.5=0.25)
    profilesSampleRate: 1.0,
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

window.addEventListener('vite:preloadError', handlePreloadError);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ConfigProvider>
    <App />
  </ConfigProvider>
);

// The backend decides whether the bug widget loads (ZLAYT-1542); it never
// blocks the app and a failure means no widget.
loadRedpenWidget();
